import { Routes } from '@angular/router';
import { AuthModule } from '@os-components';
import { LandingPageModule } from './features/landing-page/landing-page.module';

export const routes: Routes = [
    {
        path: '',
        loadChildren: () => LandingPageModule,
    },
    {
        path: 'product',
        loadChildren: () =>
            import('./features/product-page/product-page.module').then((m) => m.ProductPageModule),
    },
    {
        path: 'auth',
        loadChildren: () => AuthModule,
    },
    {
        path: '**',
        redirectTo: '',
    },
];
